// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tempLabelDelete {
  opacity: 0;
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
}

#tempLabelSelected {
  opacity: 0;
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
}

/**subtabs css starts**/
.innerHorizontalTab .nav-tabs .nav-item {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  padding-right: 10px;
}

.innerHorizontalTab .nav-tabs .nav-link {
  border: 0 !important;
  padding: 12px 15px 12px 10px;
  color: #8f9bb3;
  position: relative;
}

.innerHorizontalTab .nav-tabs .nav-link.active,
.innerHorizontalTab .nav-tabs .nav-link:hover {
  color: #36f;
}

.innerHorizontalTab .nav-tabs .nav-link.active:before {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #36f;
}

.innerHorizontalTab.innerHorizontalTabSmall .nav-tabs .nav-link {
  padding: 0px 10px 8px 10px; /*Dec 5 to reduce top spacing*/
  outline: none;
  cursor: pointer;
}

.dynamicTabList .scrtabs-tab-container {
  width: calc(100% - 70px);
}

/**Modified by Monisha Pillai***/
/**scrolling tabs***/
.scrtabs-tabs-fixed-container {
  height: 46px;
}

.scrtabs-tab-scroll-arrow {
  width: 30px;
  border: 0;
  padding: 0;
  position: relative;
}

.scrtabs-tab-scroll-arrow:hover {
  background-color: #fff;
}

.scrtabs-tab-scroll-arrow.scrtabs-tab-scroll-arrow-left {
  left: 0;
}

.scrtabs-tab-scroll-arrow.scrtabs-tab-scroll-arrow-right {
  right: 0;
}

.scrtabs-tab-scroll-arrow > span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #222b45;
  border: 1px solid #edf1f7;
  border-radius: 50%;
}

.scrtabs-tab-scroll-arrow:hover > span {
  background-color: #edf1f7;
}

.scrtabs-tab-scroll-arrow > span:before {
  content: "\\e908";
  font-family: "icomoon";
}

.scrtabs-tab-scroll-arrow.scrtabs-tab-scroll-arrow-left > span {
  transform: translate(-50%, -50%) rotate(180deg);
}

.scrtabs-disable {
  opacity: 0.3;
}

/*this is correct one**/
.innerHorizontalTab .scrolling_tabs.slick-slider .slick-arrow {
  background-color: #f2f5ff;
  width: 20px;
  height: 100%;
  border-radius: 2px;
  background-size: auto 50%;
}

.innerHorizontalTab .scrolling_tabs.slick-slider .slick-arrow.slick-prev {
  left: -10px;
}

.innerHorizontalTab .scrolling_tabs.slick-slider .slick-arrow.slick-next {
  right: -10px;
}

.innerHorizontalTab .nav-tabs .nav-item.slick-slide {
  padding-right: 0;
}

/**subtabs css ends**/
.btnAddTab {
  top: 20%;
  transform: translateY(-50%);
}

.closeFrame {
  cursor: pointer;
}

.nav-link i {
  font-size: 1.1rem;
  padding: 5px;
  line-height: 0;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/sub-tab/sub-tab.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AACF;;AACA;EACE,UAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AAEF;;AAAA,uBAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAGF;;AADA;EACE,oBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAIF;;AAFA;;EAEE,WAAA;AAKF;;AAHA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAMF;;AAJA;EACE,0BAAA,EAAA,8BAAA;EACA,aAAA;EACA,eAAA;AAOF;;AAJA;EACE,wBAAA;AAOF;;AAJA,gCAAA;AAEA,oBAAA;AACA;EACE,YAAA;AAMF;;AAJA;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAOF;;AALA;EACE,sBAAA;AAQF;;AANA;EACE,OAAA;AASF;;AAPA;EACE,QAAA;AAUF;;AARA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAWF;;AATA;EACE,yBAAA;AAYF;;AAVA;EACE,gBAAA;EACA,sBAAA;AAaF;;AAXA;EACE,+CAAA;AAcF;;AAZA;EACE,YAAA;AAeF;;AAZA,uBAAA;AACA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAeF;;AAbA;EACE,WAAA;AAgBF;;AAdA;EACE,YAAA;AAiBF;;AAfA;EACE,gBAAA;AAkBF;;AAhBA,qBAAA;AACA;EACE,QAAA;EACA,2BAAA;AAmBF;;AAhBA;EACE,eAAA;AAmBF;;AAhBA;EACE,iBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAmBF","sourcesContent":["#tempLabelDelete {\r\n  opacity: 0;\r\n  height: 0;\r\n  width: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n#tempLabelSelected {\r\n  opacity: 0;\r\n  height: 0;\r\n  width: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n/**subtabs css starts**/\r\n.innerHorizontalTab .nav-tabs .nav-item {\r\n  margin-bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-right: 10px;\r\n}\r\n.innerHorizontalTab .nav-tabs .nav-link {\r\n  border: 0 !important;\r\n  padding: 12px 15px 12px 10px;\r\n  color: #8f9bb3;\r\n  position: relative;\r\n}\r\n.innerHorizontalTab .nav-tabs .nav-link.active,\r\n.innerHorizontalTab .nav-tabs .nav-link:hover {\r\n  color: #36f;\r\n}\r\n.innerHorizontalTab .nav-tabs .nav-link.active:before {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -2px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 4px;\r\n  background-color: #36f;\r\n}\r\n.innerHorizontalTab.innerHorizontalTabSmall .nav-tabs .nav-link {\r\n  padding: 0px 10px 8px 10px; /*Dec 5 to reduce top spacing*/\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.dynamicTabList .scrtabs-tab-container {\r\n  width: calc(100% - 70px);\r\n}\r\n\r\n/**Modified by Monisha Pillai***/\r\n\r\n/**scrolling tabs***/\r\n.scrtabs-tabs-fixed-container {\r\n  height: 46px;\r\n}\r\n.scrtabs-tab-scroll-arrow {\r\n  width: 30px;\r\n  border: 0;\r\n  padding: 0;\r\n  position: relative;\r\n}\r\n.scrtabs-tab-scroll-arrow:hover {\r\n  background-color: #fff;\r\n}\r\n.scrtabs-tab-scroll-arrow.scrtabs-tab-scroll-arrow-left {\r\n  left: 0;\r\n}\r\n.scrtabs-tab-scroll-arrow.scrtabs-tab-scroll-arrow-right {\r\n  right: 0;\r\n}\r\n.scrtabs-tab-scroll-arrow > span {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #222b45;\r\n  border: 1px solid #edf1f7;\r\n  border-radius: 50%;\r\n}\r\n.scrtabs-tab-scroll-arrow:hover > span {\r\n  background-color: #edf1f7;\r\n}\r\n.scrtabs-tab-scroll-arrow > span:before {\r\n  content: '\\e908';\r\n  font-family: 'icomoon';\r\n}\r\n.scrtabs-tab-scroll-arrow.scrtabs-tab-scroll-arrow-left > span {\r\n  transform: translate(-50%, -50%) rotate(180deg);\r\n}\r\n.scrtabs-disable {\r\n  opacity: 0.3;\r\n}\r\n\r\n/*this is correct one**/\r\n.innerHorizontalTab .scrolling_tabs.slick-slider .slick-arrow {\r\n  background-color: #f2f5ff;\r\n  width: 20px;\r\n  height: 100%;\r\n  border-radius: 2px;\r\n  background-size: auto 50%;\r\n}\r\n.innerHorizontalTab .scrolling_tabs.slick-slider .slick-arrow.slick-prev {\r\n  left: -10px;\r\n}\r\n.innerHorizontalTab .scrolling_tabs.slick-slider .slick-arrow.slick-next {\r\n  right: -10px;\r\n}\r\n.innerHorizontalTab .nav-tabs .nav-item.slick-slide {\r\n  padding-right: 0;\r\n}\r\n/**subtabs css ends**/\r\n.btnAddTab {\r\n  top: 20%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.closeFrame {\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-link i {\r\n  font-size: 1.1rem;\r\n  padding: 5px;\r\n  line-height: 0;\r\n  vertical-align: middle;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
